/*
 *
 * Workspace actions
 *
 */

import * as constants from './constants';

export function setProjectList(projects) {
  return {
    type: constants.SET_PROJECT_LIST,
    projects,
  };
}

export function setSelectedProject(project) {
  return {
    type: constants.SET_SELECTED_PROJECT,
    project,
  };
}

export function getIngestionList(ingestionList) {
  return {
    type: constants.GET_INGESTION_LIST,
    ingestionList,
  };
}

export function getIngestionRecord(ingestionRecord) {
  return {
    type: constants.GET_INGESTION_RECORD,
    ingestionRecord,
  };
}

export function deleteIngestionRecord(ingestionId) {
  return {
    type: constants.DELETE_INGESTION_RECORD,
    ingestionId,
  };
}

export function setActivityLiveList(activityDetails) {
  return {
    type: constants.SET_ACTIVITY_LIVE_LIST,
    activityDetails,
  };
}

export function setElementPublishedList(elementDetails) {
  return {
    type: constants.SET_ELEMENT_PUBLISHED_LIST,
    elementDetails,
  };
}

export function setMarketDerivativeList(elementDetails) {
  return {
    type: constants.SET_MARKET_DERIVATIVE_LIST,
    elementDetails,
  };
}

export function setLanguageList(elementDetails) {
  return {
    type: constants.SET_LANGUAGE_LIST,
    elementDetails,
  };
}
